import React from "react";
import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import utilsFunctions from "../Utils/ModuleHelpers";
import { IModule, IStep } from "../Utils/Interface";
import { generalConfigurationStore as store } from "../Stores/GeneralConfigurationStore";

@observer
class SummaryModuleEntity extends React.Component {
	renderSelectedAddonModules(addonModule: IModule, step: IStep) {
		const modules = store.productConfigurationStore?.getSelectedSubModulesOfModuleInStep(addonModule, step) || [];
		const hasAddonModules = (addonModule.addonModules?.length || 0) > 0;

		return (
			<>
				{modules.length > 0 && (
					<>
						{modules.map((addonModule, index) => {
							return (
								<div className="summary-entity-wrapper" key={`${index}-summary-addon-module`}>
									<div className="summary-entity-module-title">
										<h4 className="module-title">{addonModule.title}</h4>
									</div>
									<div className="summary-entity-module-description">
										<h4 className="module-description">{store.configs?.generalDescriptionHeadline}</h4>
										<p>{addonModule.content}</p>
									</div>
								</div>
							);
						})}
					</>
				)}
				{modules.length === 0 && hasAddonModules && (
					<div className="summary-entity-wrapper">
						<div className="summary-entity-module-title">
							<h4 className="module-title">{store.configs?.summaryNoAddonModuleSelectedMessage}</h4>
						</div>
						<div className="summary-entity-module-description"></div>
					</div>
				)}
			</>
		);
	}

	renderAddonModules(step: IStep) {
		const modules = store.productConfigurationStore?.getSelectedMainModulesOfStep(step) || [];

		return (
			<>
				{modules.length > 0 &&
					modules.map((module, index) => {
						return (
							<div className="summary-entity-wrapper" key={`${index}-summary-module`}>
								<div className="summary-entity-module-image">
									<img className="module-image" src={module.thumbnail} alt={module.title} />
								</div>
								<div className="summary-entity-module-title">
									<h4 className="module-title">{module.title}</h4>
									<p className="module-sku">{module.moduleFields?.mrModuleSku}</p>
								</div>
								<div className="summary-entity-module-description">
									<h4 className="module-description">{store.configs?.generalDescriptionHeadline}</h4>
									<p>{module.content}</p>
								</div>
								<div className="addon-module-wrapper">
									{/* render selected addon module */}
									{this.renderSelectedAddonModules(module, step)}
								</div>
							</div>
						);
					})}
				{modules.length === 0 && (
					<div className="summary-entity-wrapper">
						<div className="summary-entity-module-title">
							<h4 className="module-title">{store.configs?.summaryNoModuleSelectedMessage}</h4>
						</div>
					</div>
				)}
			</>
		);
	}

	render() {
		return (
			<>
				{store.productConfigurationStore?.modules?.steps?.map((step, index) => {
					return (
						<div key={`step-${index}`} className="col-12 col-lg-11">
							{/* render step header */}
							<div className="summary-entity-header">
								<h3 key={`${index}-summary-step-header`} className="summary-entity-headline">
									{step.stepHeadline}
								</h3>
								<Link className="btn btn-simple" to={"/#" + utilsFunctions.getAnchor(step.stepHeadline)}>
									{store.configs?.generalChangeText}
								</Link>
							</div>
							{/* render selected step items */}
							{this.renderAddonModules(step)}
						</div>
					);
				})}
			</>
		);
	}
}

export default SummaryModuleEntity;
